import { CollegeScorecard, Directory, carnegieMap, institutionType } from '@common-types';

export const getSchoolInstitutionLabel = (schoolInstitutionType: number | undefined) => {
  let institutionTypeLabel = '';

  if (!schoolInstitutionType) {
    return institutionTypeLabel;
  }

  institutionType.forEach((type) => {
    if (type.institutionCodes.includes(schoolInstitutionType)) {
      institutionTypeLabel = type.label;
    }
  });

  return institutionTypeLabel;
};

export const getDefaultSchoolDescription = (
  directory: Directory | null,
  enrollment: number | null,
  collegeScorecard?: CollegeScorecard,
) => {
  if (!directory) {
    return '';
  }

  const admissionRate = collegeScorecard?.latest?.admissions?.admission_rate?.overall || 0;
  const admissionRateText = admissionRate
    ? `It has an admissions rate of ${Math.round(admissionRate * 10000) / 100}%.`
    : '';

  let popularPrograms = '';

  if (collegeScorecard?.latest?.academics?.program_percentage) {
    const programPercentages = collegeScorecard.latest.academics.program_percentage;

    const sortedPrograms = Object.entries(programPercentages)
      .sort(([, a], [, b]) => (b as number) - (a as number))
      .slice(0, 5)
      .map(([program]) => program.replace('_', ' '));

    if (sortedPrograms.length) {
      popularPrograms = `The most popular programs at ${directory.name} are ${sortedPrograms.join(', ')} studies.`;
    }
  }

  let totalStudentsEnrolledText = '';

  if (enrollment) {
    totalStudentsEnrolledText = ` with an enrollment of ${enrollment} students`;
  }
  const carnegieSizeValue = carnegieMap.get(directory?.demographics?.carnegieSizeSetting) as string;

  return `${directory.name} is a ${getSchoolInstitutionLabel(
    directory?.demographics?.institutionType,
  )?.toLocaleLowerCase()} school located in ${directory?.address?.city}, ${directory?.address?.state}.
  It is a ${carnegieSizeValue} institution${totalStudentsEnrolledText}.
  ${admissionRateText} ${popularPrograms}`;
};
